import React from 'react';
import * as PropTypes from 'prop-types';
import ActivityIndicator from '../ActivityIndicator';

PageLoading.propTypes = {
  content: PropTypes.string,
  visible: PropTypes.bool,
  wrapperClass: PropTypes.string
};

PageLoading.defaultProps = {
  content: '正在加载',
  visible: false,
  wrapperClass: ''
};

/**
 * @return {null}
 */
export default function PageLoading(props) {
  const {
    content, visible, wrapperClass, ...rest
  } = props;
  return (
    visible
      ? (
        <div className={`${wrapperClass} component-page-loading`}>
          <ActivityIndicator {...rest} />
          <h4>{content}</h4>
        </div>
      )
      : null
  );
}
